var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultTooltipConciergeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C17.3472 3 19.25 4.90279 19.25 7.25V13.8154C19.2499 16.1625 17.3471 18.0654 15 18.0654H5C2.65286 18.0654 0.750115 16.1625 0.75 13.8154V7.25C0.75 4.90279 2.65279 3 5 3H15ZM5 4.5C3.48122 4.5 2.25 5.73122 2.25 7.25V13.8154C2.25011 15.3341 3.48129 16.5654 5 16.5654H15C16.5187 16.5654 17.7499 15.3341 17.75 13.8154V7.25C17.75 5.73122 16.5188 4.5 15 4.5H5ZM9.92578 10.8877C9.96922 10.9216 10.0298 10.9216 10.0732 10.8877L14.8096 7.18164L15.25 7.79395L15.6895 8.40625L10.9541 12.1123C10.3888 12.5548 9.61125 12.5547 9.0459 12.1123L4.30957 8.40625L5.18945 7.18066L9.92578 10.8877Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultTooltipConciergeIcon);
export default __webpack_public_path__ + "static/media/vault-tooltip-concierge-icon.d95c2578f6f2d28492feff92af271398.svg";
export { ForwardRef as ReactComponent };